import apiClient from './apiClient';

export const getTermsSections = async () => {
  const { data } = await apiClient.get('/api/terms');
  return Array.isArray(data) ? data : [];
};

export const saveTermsSections = async (sections) => {
  const { data } = await apiClient.put('/api/terms', sections || []);
  return Array.isArray(data) ? data : [];
};

